import React from 'react';

import { Button } from '@mui/material';

import useAuthenticationContext from '../shared/context/authentication/authentication.context';
import useRouteHelper from '../shared/routes/useRouteHelper.hook';


interface IProps {
  nextRouteUrl?: string;
}
function AuthenticationPage({ nextRouteUrl }: IProps) {

  const { login } = useAuthenticationContext();
  const { gotoUserPage, gotoUrlOrBack } = useRouteHelper();

  const handleLogin = () => {

    // TODO: handle token and others here
    login(true);

    // navigate user
    if (nextRouteUrl) {
      // gotoUrlOrBack(nextRouteUrl);
      gotoUserPage();
    } else {
      gotoUserPage();
    }

  }

  return (
    <Button color='primary' variant='contained' onClick={handleLogin}>Auto Login</Button>
  );
}
export default AuthenticationPage;